import { getFieldLabel } from "../../forecastContext";

// Dimensions whose inventory is shared across sales splits — the intake facts
// carry no sales_location / country columns (mirrors the backend
// SHARED_INVENTORY_KEYS).
const SHARED_INVENTORY_KEYS = ["sales_location", "country"];

/**
 * Confirm-dialog warning for a rename / merge under a sales-location /
 * country filter: such a filter scopes the operation to the sales grain, so
 * mapped dimensions the intake grain (the stock pool) also stores are left
 * unchanged there — intake has no location split and cannot be partially
 * rewritten.
 */
export function intakeScopeWarning(
  selections: Record<string, string[]>,
  mappedKeys: string[]
): string | undefined {
  const locationFilters = SHARED_INVENTORY_KEYS.filter(
    (key) => (selections[key] ?? []).length > 0
  );
  const intakeDims = mappedKeys.filter(
    (key) => !SHARED_INVENTORY_KEYS.includes(key)
  );
  if (locationFilters.length === 0 || intakeDims.length === 0) {
    return undefined;
  }
  return (
    `${locationFilters.map(getFieldLabel).join(" / ")} filter active — ` +
    "intake (the stock pool) has no location split, so it is excluded: " +
    `${intakeDims.map(getFieldLabel).join(", ")} changes on sales metrics ` +
    "only and intake keeps the current values."
  );
}
